<adv-growl></adv-growl>
<div id="container-iclass">
    <div class="center-div">    
        <p-card header="Criar uma Conta"  [style]="{width: '360px'}" >
            <div class="ui-g ui-fluid">
                <input type="hidden" id="idEmpresa" name="idEmpresa" pInputText [(ngModel)]="primeiroAcesso.idEmpresa">              
                <div class="ui-g-12 ui-md-12">
                    <div class="ui-inputgroup">
                        <span class="ui-inputgroup-addon"><i class="fas fa-key"></i></span>
                        <input type="email" 
                               name="email" 
                               pInputText
                               i18n-placeholder 
                               placeholder="E-mail"
                               [(ngModel)]="email">
                    </div>
                </div>                
                <div class="ui-g-12 ui-md-12">
                    <div class="ui-inputgroup" >
                        <div class="ui-g-12"><p-radioButton [hidden]="hideMask" name="group1" value="cpf"  label="CPF"  [(ngModel)]="cpf"  inputId="opt_cpf" (ngModelChange)="onChange($event)"></p-radioButton></div>
                        <div class="ui-g-12"><p-radioButton [hidden]="hideMask" name="group1" value="cnpj" label="CNPJ" [(ngModel)]="cnpj" inputId="opt_cnpj" (ngModelChange)="onChange($event)"></p-radioButton></div>
                    </div>    
                    <div class="ui-inputgroup">
                        <span class="ui-inputgroup-addon"><i class="fas fa-user"></i></span>
                        <input [mask]="mask"  type="text"  
                               [disabled]="isDisabled" 
                               name="documento" 
                               pInputText
                               i18n-placeholder 
                               placeholder="CPF/CNPJ"
                               [(ngModel)]="documento">
                    </div>
                </div>
            </div>
            <p-footer>
                <div style="text-align: right">
                    <button pButton type="button"
                            i18n-label 
                            label="Cadastre-se" 
                            icon="pi pi-check" 
                            (click)="doRegister()">
                    </button>
                </div>
            </p-footer>
        </p-card>

        <br />
        <p-card header="Fazer Login" [style]="{width: '360px'}" styleClass="ui-card-shadow">
        <p-footer>
            <p>
            <a [routerLink]="['/login']">
                <span class="topbar-submenu-icon fas fa-plus-circle"></span>
                <strong>
                    <label i18n="@@labelText36">Assinar em</label>
                </strong>
            </a>
            </p>
        </p-footer>
        </p-card>
    </div>
</div>
